module.exports = __webpack_public_path__ + "static/media/player-agent.4c177939.svg";